import { BadgeData } from './types';
import { StyledMiddleBadge } from './style';
import { EBadgePosition } from 'utils/enums';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

function Badge(badgeData: BadgeData & { position: EBadgePosition }) {
  const emblemPic =
    badgeData.emblem?.imageUrl || badgeData.badge?.emblem?.imageUrl;
  const ribbonText = badgeData.ribbon?.text || badgeData.badge?.ribbon?.text;
  const background = emblemPic
    ? `url(${emblemPic})`
    : 'url(https://media.appcharge.com/defaults/sale_ribbon_center.png)';
  const isTextAutoResized = badgeData?.isTextAutoResized;

  return (
    <StyledMiddleBadge
      background={background}
      textColor={badgeData.ribbon?.textColor}
      position={badgeData.position || badgeData.badge?.position}
      className="middle-badge"
    >
      {ribbonText && isTextAutoResized ? (
        <AutoTextSize
          as="p"
          mode="oneline"
          maxFontSizePx={14}
          minFontSizePx={8}
          className="autoResizedText"
        >
          {ribbonText}
        </AutoTextSize>
        ) : (
        <p data-text={ribbonText} >{ribbonText}</p>
      )}
    </StyledMiddleBadge>
  );
}

export default Badge;
